import { useQuery } from '@tanstack/react-query'

import { ULR_QUERY_PARAM, mapCartStoreToUrlQuery } from '@/features/url-handling'
import { useCartStore } from '@/stores/cart-store/cartStore'

import { getSupportCode } from '../api/getSupportCode'

export const SUPPORT_CODE_QUERY_KEY = 'GET_SUPPORT_CODE'

export const useSupportCode = () => {
	return useQuery({
		queryKey: [SUPPORT_CODE_QUERY_KEY],
		queryFn: () => {
			const cartState = useCartStore.getState()

			const searchParams = new URLSearchParams()
			searchParams.set(ULR_QUERY_PARAM, JSON.stringify(mapCartStoreToUrlQuery(cartState)))

			return getSupportCode(
				`${window.location.origin}${window.location.pathname}?${searchParams.toString()}`
			)
		},
		enabled: false,
		refetchOnWindowFocus: false,
	})
}
